export default "__VITE_ASSET__e587ef4e__ 600w, __VITE_ASSET__c1a7de12__ 960w, __VITE_ASSET__e3b23e28__ 1280w, __VITE_ASSET__9f190610__ 1920w";